import React from "react";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import SafeTypeTable from "./view/SafeTypeTable";

interface SafeTypeProps {}
export const SafeType: React.FC<SafeTypeProps> = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_securityconfiguration_safetype_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return <> {userPermissions.includes(viewPermission) && <SafeTypeTable />} </>;
};
export default SafeType;
